<div
  dgxSticky
  stickyCustomClass="box-shadow bg-color-ebony-a03-hue sticky-filter-bar"
>
  <fieldset
    class="rounded--large guts-p-full-1 bg-color-ebony-a03-hue"
    tabindex="0"
    [attr.aria-label]="i18n.Core_SearchFilterA11yLabel"
  >
    <!-- Filters -->
    <ng-container *ngIf="showFilters$ | async">
      <ng-container *ngIf="!showSkeleton; else skeleton">
        <div class="l_flexbar m-l_flexbar-col">
          <ng-content></ng-content>
        </div>
      </ng-container>
    </ng-container>

    <!-- Filter toggle -->
    <button
      *ngIf="isMobile$ | async"
      type="button"
      class="sticky-filter-bar__toggle font-semibold color-blue m-full-width"
      (click)="toggleFilters()"
    >
      {{ toggleButtonLabel$ | async }}
    </button>
  </fieldset>
</div>

<!-- Loading skeleton -->
<ng-template #skeleton>
  <div class="skeleton-container">
    <dgx-skeleton type="search-filters" [columns]="filterCount"></dgx-skeleton>
  </div>
</ng-template>
